<template>
  <div class="card">
    <router-link v-if="posts.content_type"
      :to="{
        name: 'BlogSingle',
        params: { 
            locale: this.locale,
            blogId: posts.id,
            blogName: posts.slug
        }
      }"
    >
      <img :src="`${posts.cover}`" :alt="posts.title" :width="isMobile?319:393" :height="isMobile?180:222" loading="lazy">
    </router-link>
    <a v-else :href="posts.link_redirect">
      <img :src="`${posts.cover}`" :alt="posts.title" :width="isMobile?319:393" :height="isMobile?180:222" loading="lazy">
    </a>    
    <div class="card-body">
      <router-link v-if="posts.content_type"
        :to="{
          name: 'BlogSingle',
          params: { 
              locale: this.locale,
              blogId: posts.id,
              blogName: posts.slug
          }
        }"
      >
        <div :class="homepage ? 'card-title' : 'card-title-mobile'">{{ posts.title }}</div>
      </router-link>    
      <a v-else :href="posts.link_redirect">
        <div :class="homepage ? 'card-title' : 'card-title-mobile'">{{ posts.title }}</div>
      </a>    

      <p
        class="card-text"
        v-for="description in posts.meta_description"
        :key="description.language_id"
      >
        <span
          v-if="description.language_id === 1 && locale === 'pt-br'"
          v-text="description.content"
        ></span>
        <span
          v-if="description.language_id === 2 && locale === 'en'"
          v-text="description.content"
        ></span>
      </p>
      <div class="row">
        <p class="card-text small col-6" v-if="posts.content_type">
          <font-awesome-icon :icon="['far', 'comment-dots']" size="sm" /> {{ posts.comments }}
          {{ translateMain.commentsBlog }}
        </p>
        <p class="card-text small col-6">
          <font-awesome-icon :icon="['far', 'clock']" size="sm" /> {{ posts.date }}
        </p>
      </div>

      <router-link v-if="posts.content_type"
        :to="{
          name: 'BlogSingle',
          params: { 
              locale: this.locale,
              blogId: posts.id,
              blogName: posts.slug
           }
        }"
        class="button--more"
      >
        {{ translateMain.moreBlog }}
        <font-awesome-icon :icon="['fas', 'arrow-right']" size="sm" style="margin-left: 6px;" />
      </router-link>
      <a v-else :href="posts.link_redirect" class="button--more">
        {{ translateMain.moreBlog }}
        <font-awesome-icon :icon="['fas', 'arrow-right']" size="sm" style="margin-left: 6px;" />
      </a>    

      <div>&nbsp;</div>
    </div>
  </div>
</template>

<script lang="ts">
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import translateMain from 'tradutors/menu'
  import router from '../../router'
  import { isMobile } from 'views/shared/utils/mobile'  

  export default {
    name: 'PostListItem',
    props: ['posts', 'homepage'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translateMain: function () {
        if (this.locale === 'pt-br') {
          return translateMain.portugues
        } else {
          return translateMain.ingles
        }
      },
      image() {
        return `${this.$root.baseUrl}/storage/blog/${this.post.cover}`
      },
      findImage(file) {
        return `${this.$root.baseUrl}/storage/blog/${file}`
      }
    },
    data() {
      return {
        isMobile: isMobile(),
      }
    },    
    methods: {
      redirect(name, id, slug) {
        router.push({ name , params: { locale: this.locale, blogId: id, blogName: slug } })
      },
    }
  }
</script>
<style scoped>

  .card >>> .card-body {
    padding: 5px 0px 0px;
  }

  .card-body p {
    margin-bottom: 5px;
  }
  .card-title {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    margin-bottom: 5px;
  }

  .card-title-mobile {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    margin-bottom: 14px;
  }

  .card-text span {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    display: block;
  }

  .small {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    margin-bottom: 0px !important;
  }
  .button--more svg {
    color: #b20000;
  }

  .button--more {
    height: 19px;
    color: #666666;
    font-family: "Exo-2";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: right;
  }

  .small svg {
    margin-right: 5px;
  }

  .card img {
    width: 100%;
    object-fit: cover;
    cursor: pointer;
  }

  .card {
    background-color: var(--bs-white);
    width: 99%;
    color: #5b5858;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .card {
      width: 100%;
    }
  }
</style>
